import styles from './DashboardHeader.module.css';
import { Button, Dropdown, MenuProps, Space, Tooltip, Row, Col, Typography } from 'antd';
import { Link } from 'react-router-dom';
import Icon from '../../Icon/Icon';
import ProductName from '../../Brand/ProductName';
import {
  BUG_REPORT_URL,
  FEEDBACK_EMAIL,
  USER_GUIDE_URL,
  TOOL_NAME,
  VERSION_NUMBER,
  RESPONSIBLE,
  HELP_EMAIL,
  COPYRIGHT,
} from 'src/app/constants';
import Modal from '../../Modal';
import { useState } from 'react';
import useAuth from 'src/hooks/useAuth';

const { Title } = Typography;

const DashboardHeader = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openBugReportModal, setOpenBugReportModal] = useState(false);
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const { logout, user } = useAuth();

  const handleHelpMenuClick = (e: { key: string }) => {
    if (e.key === '1') {
      setOpenBugReportModal(true);
    } else if (e.key === '2') {
      setOpenFeedbackModal(true);
    } else if (e.key === '3') {
      window.open(USER_GUIDE_URL, '_blank');
    } else if (e.key === '4') {
      setOpenModal(true);
    }
  };

  const sidebarItemStyles = {
    borderTop: '1px solid #4c4c4c',
    borderRadius: '0px',
  };

  const moreItems: MenuProps['items'] = [
    {
      key: '1',
      label: 'Create a bug report',
    },
    {
      key: '2',
      label: 'Send a feedback',
    },
    {
      key: '3',
      label: 'VFDB User Guide',
    },
    {
      key: '4',
      label: 'About JLR NextGen Vehicle Feedback Database',
      style: sidebarItemStyles,
    },
  ];
  const handleMenuClick = (e: { key: string }) => {
    if (e.key == 'DTC/1000') {
      window.open(
        'https://lookerstudio.google.com/u/0/reporting/1r63drdQf5kA0yxIptUu8X5Z1O--dJqne/page/yy4QB',
        '_blank'
      );
    }
  };
  const items = [{ label: 'DTC/1000', key: 'DTC/1000' }];
  const menu = { items, onClick: handleMenuClick };

  return (
    <div className={styles.DashboardHeader}>
      <Space direction="horizontal">
        <ProductName />
      </Space>
      <Space direction="horizontal">
        <div className={styles['DashboardHeader--UserName']}>
          <span>{user?.name}</span>
        </div>
        <div className={styles['DashboardHeader--NavSeparator']}>
          {/* <Dropdown menu={menu}>
          <Button>
            <Space>Dashboards</Space>
          </Button>
        </Dropdown> */}
        </div>
        <Dropdown menu={menu}>
          <Button className={styles['DashboardHeader--Button']}>
            <Space>Dashboards</Space>
          </Button>
        </Dropdown>
        {/* <Dropdown overlay={menu} trigger={['click']}> <Button> Dashboard </Button> </Dropdown> */}
        <div className={styles['DashboardHeader--NavSeparator']}></div>
        <Dropdown menu={{ items: moreItems, onClick: handleHelpMenuClick }} trigger={['click']}>
          <Tooltip title="Help">
            <Button type="text" size="large" className={styles['DashboardHeader--NavButton']}>
              <Icon name="help" />
            </Button>
            <Modal
              onClose={() => setOpenBugReportModal(false)}
              width={750}
              open={openBugReportModal}
              footer={<span></span>}
            >
              <Title className={styles['DashboardHeader--BugReportModalTiTle']}>Bug report</Title>
              <div className={styles['DashboardHeader--BugReportModalMessage']}>
                <div>To raise a bug please use the link below:</div>
                <div style={{ paddingTop: '0.5em' }}>
                  <Link to={BUG_REPORT_URL} target="_blank" rel="noopener noreferrer">
                    {' '}
                    {BUG_REPORT_URL}
                  </Link>
                </div>
                <div style={{ paddingTop: '1.5em', paddingBottom: '1em' }}>
                  <b>Note:</b>
                  <span>
                    {' '}
                    Please set the issue type to &apos;Bug&apos;, assign the team as
                    &apos;D3MDatashare&apos;, and assign the ticket to &apos;Srinivasan Gujulan
                    Sathiyamurthy (sgujulan)&apos;
                  </span>
                </div>
              </div>
            </Modal>
            <Modal
              onClose={() => setOpenFeedbackModal(false)}
              width={750}
              open={openFeedbackModal}
              footer={<span></span>}
            >
              <Title className={styles['DashboardHeader--BugReportModalTiTle']}>Feedback</Title>

              <div className={styles['DashboardHeader--BugReportModalMessage']}>
                <div>
                  For any questions or feedback, please reach out to the email address or group
                  listed below:
                </div>

                <div style={{ paddingTop: '0.5em' }}>
                  <a href={`mailto:${FEEDBACK_EMAIL}`}> {FEEDBACK_EMAIL} (VFDB/VFA support_GRP)</a>
                </div>
              </div>
            </Modal>
            <Modal open={openModal} onClose={() => setOpenModal(false)} width={600} footer={null}>
              <div className={styles['DashboardHeader--ModalHeader']}>
                About JLR NextGen Vehicle Feedback Database
              </div>
              <div className={styles['DashboardHeader--ModalBody']}>
                <div className={styles['DashboardHeader--ModalToolName']}>{TOOL_NAME}</div>
                <div className={styles['DashboardHeader--ModalContent']}>
                  <Row gutter={16}>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      Version:
                    </Col>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      {VERSION_NUMBER}
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      Responsible:
                    </Col>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      {RESPONSIBLE}
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      Help Email:
                    </Col>
                    <Col span={12} style={{ fontSize: '15.33px' }}>
                      {HELP_EMAIL}
                    </Col>
                  </Row>
                </div>
              </div>
              <div className={styles['DashboardHeader--ModalFooter']}>
                <div className={styles['DashboardHeader--ModalFooterContent']}>
                  <div>{TOOL_NAME}</div>
                  <div>{COPYRIGHT}</div>
                </div>
              </div>
            </Modal>
          </Tooltip>
        </Dropdown>
        <div className={styles['DashboardHeader--NavSeparator']}></div>
        <Tooltip title="Logout">
          <Button
            type="text"
            size="large"
            className={styles['DashboardHeader--NavButton']}
            onClick={logout}
          >
            <Icon name="logout" />
          </Button>
        </Tooltip>
      </Space>
    </div>
  );
};

export default DashboardHeader;
